import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
 
// 10 terms (same structure as your sample)
const TEMPLATES = [
  "I confirm that all information provided is true and accurate.",
  "I will not share my account credentials with others.",
  "Vouchers are non-transferable and valid only for the stated period.",
  "I agree to receive notifications related to voucher usage and offers.",
  "Misuse or fraudulent activity may result in account suspension.",
  "I consent to collection of usage data to improve services.",
  "I acknowledge terms may change and agree to review updates.",
  "I will follow all rules when redeeming vouchers and offers.",
  "I agree not to attempt reverse-engineering or tampering with this app.",
  "I accept the app's privacy policy and refund/cancellation policy."
];
 
const LoginPage = ({ handleLogin }) => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
 
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const [currentTerms, setCurrentTerms] = useState([]);
 
  const formRef = useRef(null);
 
  const pickFiveRandom = () => {
    const copy = [...TEMPLATES];
    const result = [];
    for (let i = 0; i < 5 && copy.length > 0; i++) {
      const idx = Math.floor(Math.random() * copy.length);
      result.push(copy.splice(idx, 1)[0]);
    }
    return result;
  };
 
  // STEP 1: Intercept submit → show terms modal
  const onSubmit = (e) => {
    e.preventDefault();
    setTermsChecked(false);
    setCurrentTerms(pickFiveRandom());
    setShowTermsModal(true);
  };
 
  // STEP 2: After Agree → call original handleLogin
  const onAgree = () => {
    if (!termsChecked) return;
 
    setShowTermsModal(false);
 
    // simulate the normal form submit event for handleLogin
    const syntheticEvent = {
      preventDefault: () => {},
      target: {
        elements: {
          username: { value: userId },
          userId: { value: userId },
          password: { value: password }
        },
        username: { value: userId },
        userId: { value: userId },
        password: { value: password }
      }
    };
 
    try {
      handleLogin(syntheticEvent, navigate);
    } catch (err) {
      try {
        handleLogin({ username: userId, password }, navigate);
      } catch (err2) {
        console.error("handleLogin failed:", err, err2);
      }
    }
  };
 
  const handleCancel = () => {
    setUserId("");
    setPassword("");
  };
 
  return (
    <div className="login-page">
      <div className="login-card">
        <h2 className="page-title">Login</h2>
 
        <form onSubmit={onSubmit} ref={formRef} className="form-grid">
          {/* User ID */}
          <div className="form-group full-width">
            <label htmlFor="userId" className="form-label">User ID</label>
            <input
              type="text"
              name="username"
              id="userId"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              placeholder="Enter your User ID"
              className="form-input"
              required
            />
          </div>
 
          {/* Password */}
          <div className="form-group full-width">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type="password"
              name="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              className="form-input"
              required
            />
          </div>
 
          {/* Buttons */}
          <div className="button-group full-width">
            <button type="submit" className="btn btn-primary">Submit</button>
            <button type="button" onClick={handleCancel} className="btn btn-secondary">Cancel</button>
          </div>
 
          {/* Forgot Password */}
          <div className="form-footer" style={{ marginTop: "10px" }}>
            <Link to="/forgot-password" className="link-forgot">
              Reset/Forgot password?
            </Link>
          </div>
        </form>
      </div>
 
      {/* TERMS MODAL (same style pattern you provided) */}
      {showTermsModal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h3 style={{ marginTop: 0, color: "#fff" }}>Terms & Conditions</h3>
 
            <div style={styles.termsBox}>
              <ol style={{ paddingLeft: 18, margin: 0 }}>
                {currentTerms.map((t, i) => (
                  <li key={i} style={{ marginBottom: 8, color: "#e6eef3" }}>{t}</li>
                ))}
              </ol>
            </div>
 
            <div style={{ display: "flex", alignItems: "center", marginTop: 12 }}>
              <input
                type="checkbox"
                checked={termsChecked}
                onChange={(e) => setTermsChecked(e.target.checked)}
                style={{ width: 16, height: 16 }}
              />
              <label style={{ marginLeft: 8, color: "#e6eef3" }}>
                I accept the terms and conditions
              </label>
            </div>
 
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
              <button
                onClick={() => setShowTermsModal(false)}
                style={styles.backBtn}
                type="button"
              >
                Back
              </button>
 
              <button
                onClick={onAgree}
                type="button"
                disabled={!termsChecked}
                style={{
                  ...styles.agreeBtn,
                  opacity: termsChecked ? 1 : 0.6,
                  cursor: termsChecked ? "pointer" : "not-allowed"
                }}
              >
                Agree
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
 
export default LoginPage;
 
/* --- Modal inline styles --- */
const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
  },
  modal: {
    width: 520,
    maxWidth: "90%",
    borderRadius: 10,
    padding: 20,
    background: "linear-gradient(180deg, rgba(22,29,36,0.98), rgba(18,24,30,0.98))",
    boxShadow: "0 10px 30px rgba(0,0,0,0.6)"
  },
  termsBox: {
    maxHeight: 220,
    overflowY: "auto",
    background: "rgba(255,255,255,0.02)",
    border: "1px solid rgba(255,255,255,0.03)",
    padding: 12,
    borderRadius: 6,
    marginTop: 8
  },
  backBtn: {
    padding: "8px 14px",
    borderRadius: 6,
    border: "none",
    background: "#3b4550",
    color: "#fff"
  },
  agreeBtn: {
    padding: "8px 14px",
    borderRadius: 6,
    border: "none",
    background: "#1e88e5",
    color: "#fff"
  }
};